// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"504":"chunk-vendors","6851":"chunk-common-a5792c09","7299":"chunk-common-1cf0a49d"}[chunkId] + "." + {"504":"86edc49a","6851":"933b358f","7299":"550265b1"}[chunkId] + ".css";
};